import HandleResponses from '@common/utils/handleApiResponsesV2';

import { getUserAssociatedDepots } from '@/api-factory/user';
import { searchDepots, getConsignees, getContracts, createIndent, updateIndent, checkVehicleCongestion, createFromDraft, getIndentBootstrap, getPurchaseOrderFieldsList, updateHachIndent, getConsigneeSingleData, updateConsigneeSingleData } from '@/api-factory/order';
import { getVehicleTypes } from '@/api-factory/vehicle-type';
import { getActiveTransporters } from '@/api-factory/transporter';
import { addConsignee } from '@/api-factory/consignee';

const actions = {
  async getAssociatedDepots({ commit }, { id, filters }) {
    try {
      commit('setIsLoading', true);
      const result = await getUserAssociatedDepots(id, filters);
      if (result && result.data) {
        commit('setList', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setIsLoading', false);
    }
  },

  async getDepotsByType({ commit }, params) {
    try {
      commit('setIsLoading', true);
      const result = await searchDepots(params.filters);
      if (result && result.data) {
        commit('setList', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setIsLoading', false);
    }
  },
  async getDepotsByTypeSoldTo({ commit }, params) {
    try {
      commit('setIsLoadingSoldTo', true);
      const result = await searchDepots(params.filters);
      if (result && result.data) {
        commit('setListSoldTo', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setIsLoadingSoldTo', false);
    }
  },

  async getConsignees({ commit }, params) {
    try {
      commit('setIsLoading', true);
      const result = await getConsignees(params.filters);
      if (result && result.data) {
        commit('setList', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setIsLoading', false);
    }
  },

  async getConsigneesSoldTo({ commit }, params) {
    try {
      commit('setIsLoadingSoldTo', true);
      const result = await getConsignees(params.filters);
      if (result && result.data) {
        commit('setListSoldTo', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setIsLoadingSoldTo', false);
    }
  },

  async getContract(_, data) {
    try {
      const result = await getContracts(data);
      return result && result.data;
    } catch (error) {
      return error;
    }
  },

  async getAllVehicles({ commit }, params) {
    try {
      const result = await getVehicleTypes(params);
      if (result && result.data) {
        commit('setMasterVehiclesList', result.data);
      }
      return result && result.data;
    } catch (error) {
      return error;
    }
  },

  async getAllTransporters({ commit, state }) {
    try {
      const existingData = state.masterTransportersList;
      if (existingData.length > 0) {
        return existingData;
      }
      const result = await getActiveTransporters();
      if (result && result.data) {
        commit('setMasterTransportersList', result.data);
      }
      return result && result.data;
    } catch (error) {
      return error;
    }
  },

  async createIndent({ commit }, { data, allTransportersSelected }) {
    try {
      commit('setIsOrderProcessing', true);
      const result = await createIndent(data, allTransportersSelected);
      return result && result.data;
    } catch (error) {
      const err = HandleResponses.Status(error);
      if (err && err.error === 'Validation  error - request - ERR_ACCEPTANCE_SLA_NOT_FOUND') {
        return {
          error: 'ERR_ACCEPTANCE_SLA_NOT_FOUND',
        };
      }
      return err;
    } finally {
      commit('setIsOrderProcessing', false);
    }
  },


  async createIndentFromDraft({ commit }, { id, data, allTransportersSelected }) {
    try {
      commit('setIsOrderProcessing', true);
      const result = await createFromDraft(id, data, allTransportersSelected);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setIsOrderProcessing', false);
    }
  },

  async updateIndent({ commit }, { id, data, isOptimaIndent }) {
    try {
      commit('setIsOrderProcessing', true);
      const result = await updateIndent(id, data, isOptimaIndent);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setIsOrderProcessing', false);
    }
  },
  async updateHachIndent({ commit }, { id, data }) {
    try {
      commit('setIsOrderProcessing', true);
      const result = await updateHachIndent(id, data);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setIsOrderProcessing', false);
    }
  },
  async addConsignee({ commit }, data) {
    try {
      const result = await addConsignee(data);
      if (result && result.data) {
        commit('addToList', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async checkVehicleCongestion(_, data) {
    try {
      const result = await checkVehicleCongestion(data);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async indentBootstrap({ commit }) {
    try {
      const result = await getIndentBootstrap();
      if (result && result.data) {
        commit('setIndentBootstrap', result.data);
        if (result.data.is_lr_mandatory_for_mark_as_delivered) {
          commit('setIsLrMandatoryForMarkAsDelivered',
            result.data.is_lr_mandatory_for_mark_as_delivered);
        }
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async purchaseOrderFieldsListData(_, params) {
    try {
      const result = await getPurchaseOrderFieldsList(params);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getConsigneeData(_, consigneeId) {
    try {
      const result = await getConsigneeSingleData(consigneeId);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async updateConsigneeData(_, { payload, consigneeId }) {
    try {
      const result = await updateConsigneeSingleData({ payload, consigneeId });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
};

export default actions;
